import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["frame", "status"]
  static values = { url: String }

  connect() {
    if ("IntersectionObserver" in window) {
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return

        this.observer.disconnect()
        this.loadPreview()
      }, { rootMargin: "300px" })
      this.observer.observe(this.element)
    } else {
      this.loadPreview()
    }
  }

  disconnect() {
    if (this.observer) this.observer.disconnect()
    if (this.onFrameLoad) this.frameTarget.removeEventListener("load", this.onFrameLoad)
  }

  loadPreview() {
    if (this.frameTarget.getAttribute("src")) return

    this.statusTarget.hidden = false
    this.statusTarget.textContent = "Chargement de l'aperçu…"
    this.onFrameLoad = () => { this.statusTarget.hidden = true }
    this.frameTarget.addEventListener("load", this.onFrameLoad, { once: true })
    // Let the browser's PDF viewer load the authenticated response directly.
    // Blob frames inherit the dashboard CSP, which disallows PDF objects.
    this.frameTarget.src = this.urlValue
  }
}
